module.exports = __webpack_public_path__ + "media/images/iconEdit-61bc844f88efe47dc031cd7cf49d6da4.png";